<template>
<div class="main-content">
  <div class="login-header">
    <img src="@/assets/images/logo.png">
    <span>Express EDC 系统</span>
  </div>
  <h2 class="login-title">用户登录</h2>
  <login-from></login-from>
</div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/login/Login.vue'

export default {
  name: 'login',
  components: {
    'login-from': Login
  }
}
</script>

<style>
.login-title {
  text-align: center;
  padding: 2% 0 2%;
}
.login-header img {
  height: 72px;
  padding-top: 36px;
  padding-right: 10px;
}
.login-header {
  text-align: center;
  padding: 2% 0;
  font-size: 3.8em;
  font-weight: bolder;
  color: #1f81f5;
  text-shadow: 3px 3px 3px #f79b20;
}
</style>
